import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProgressTrackerSupportService {
  public readonly currentStep: WritableSignal<number> = signal(0);
}
